/* eslint-disable */
import Vue from 'vue';
import Loading from './loading.vue';
import { addClass, removeClass, hasClass, getStyle } from '../../../utils/dom';
import { PopupManager } from 'element-ui/lib/utils/popup';
import afterLeave from '../../../utils/after-leave';
const Mask = Vue.extend(Loading);

const loadingDirective = {};
loadingDirective.install = vmVue => {
  const toggleLoading = (el, binding) => {
    if (binding.value) {
      vmVue.nextTick(() => {
        if (binding.modifiers.body) {
          el.originalPosition = getStyle(document.body, 'position');

          ['top', 'left'].forEach(property => {
            const scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
            el.maskStyle[property] =
              el.getBoundingClientRect()[property] +
              document.body[scroll] +
              document.documentElement[scroll] -
              parseInt(getStyle(document.body, `margin-${property}`), 10) +
              'px';
          });
          ['height', 'width'].forEach(property => {
            el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px';
          });

          if (binding.modifiers.fullscreen) {
            el.originalOverflow = getStyle(document.body, 'overflow');
            el.maskStyle.zIndex = PopupManager.nextZIndex();
          }

          insertDom(document.body, el, binding);
        } else {
          el.originalPosition = getStyle(el, 'position');
          insertDom(el, el, binding);
        }
      });
    } else {
      afterLeave(
        el.instance,
        _ => {
          if (!el.instance.hiding) return;
          el.domVisible = false;
          const target = binding.modifiers.fullscreen || binding.modifiers.body ? document.body : el;
          removeClass(target, 'rt-loading-parent--relative');
          removeClass(target, 'rt-loading-parent--hidden');
          el.instance.hiding = false;
        },
        300,
        true
      );
      el.instance.visible = false;
      el.instance.hiding = true;
    }
  };
  const insertDom = (parent, el, binding) => {
    if (!el.domVisible && getStyle(el, 'display') !== 'none' && getStyle(el, 'visibility') !== 'hidden') {
      Object.keys(el.maskStyle).forEach(property => {
        el.mask.style[property] = el.maskStyle[property];
      });
      if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {
        addClass(parent, 'rt-loading-parent--relative');
      }
      addClass(parent, 'rt-loading-parent--hidden');
      el.domVisible = true;

      parent.appendChild(el.mask);
      vmVue.nextTick(() => {
        if (el.instance.hiding) {
          el.instance.$emit('after-leave');
        } else {
          el.instance.visible = true;
        }
      });
      el.domInserted = true;
    } else if (el.domVisible && el.instance.hiding === true) {
      el.instance.visible = true;
      el.instance.hiding = false;
    }
  };

  vmVue.directive('loading', {
    bind: function (el, binding, vnode) {
      const textExr = el.getAttribute('rt-loading-text');
      const typeExr = el.getAttribute('rt-loading-type');
      const sizeExr = el.getAttribute('rt-loading-size');
      const textColorExr = el.getAttribute('rt-loading-text-color');
      let backgroundExr = el.getAttribute('rt-loading-background');
      if (!backgroundExr) {
        if (hasClass(el, 'rt-view')) {
          backgroundExr = '#f5f6fa';
        } else {
          backgroundExr = 'rgba(255,255,255,0.5)';
        }
      }
      const _vm = vnode.context;
      const mask = new Mask({
        el: document.createElement('div'),
        data: {
          text: (_vm && _vm[textExr]) || textExr,
          type: (_vm && _vm[typeExr]) || typeExr,
          size: (_vm && _vm[sizeExr]) || sizeExr,
          textColor: (_vm && _vm[textColorExr]) || textColorExr,
          background: (_vm && _vm[backgroundExr]) || backgroundExr
        }
      });
      el.instance = mask;
      el.mask = mask.$el;
      el.maskStyle = {};

      binding.value && toggleLoading(el, binding);
    },

    update: function (el, binding) {
      el.instance.setText(el.getAttribute('rt-loading-text'));
      if (binding.oldValue !== binding.value) {
        toggleLoading(el, binding);
      }
      el.instance.setType(el.getAttribute('rt-loading-type'));
      if (binding.oldValue !== binding.value) {
        toggleLoading(el, binding);
      }
      el.instance.setSize(el.getAttribute('rt-loading-size'));
      if (binding.oldValue !== binding.value) {
        toggleLoading(el, binding);
      }
      el.instance.setTextColor(el.getAttribute('rt-loading-text-color'));
      if (binding.oldValue !== binding.value) {
        toggleLoading(el, binding);
      }
    },

    unbind: function (el, binding) {
      if (el.domInserted) {
        el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
        toggleLoading(el, { value: false, modifiers: binding.modifiers });
      }
      el.instance && el.instance.$destroy();
    }
  });
};

export default loadingDirective;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/loading/src/directive.js